import React, { FC } from "react";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { SimpleGrid } from "@UI/Components/SimpleGrid/SimpleGrid";
import { Box } from "@UI/Components/Box/Box";
import { SubscriptionPlanCard } from "../SubscriptionPlanCard/SubscriptionPlanCard";
import { useSubscriptionPlans } from "@modules/Subscriptions/hooks/useSubscriptionPlans";
import { ISubscriptionPlan } from "@modules/Subscriptions/types";
import { useSubscriptionsFeature } from "@modules/Subscriptions/hooks/useSubscriptionsFeature";

interface Props {
  onSelect: (plan: ISubscriptionPlan) => void;
}

export const SelectSubscriptionPlan: FC<Props> = ({ onSelect }) => {
  const { subscriptionPlans, isLoading } = useSubscriptionPlans();
  const { isLoading: isSubscriptionsFeatureLoading, getPlanContent } =
    useSubscriptionsFeature();

  if (isLoading || isSubscriptionsFeatureLoading) {
    return <LoadingScreen />;
  }

  const planEnabled = (plan: ISubscriptionPlan) => {
    const cmsContentForPlan = getPlanContent(plan);
    return cmsContentForPlan?.enabled;
  };
  const enabledPlans = subscriptionPlans.filter(planEnabled);

  return (
    <SimpleGrid
      columns={{ base: 1, lg: enabledPlans.length % 2 === 0 ? 2 : 3 }}
      justifyContent="center"
      spacing={{ base: 4, lg: 6 }}
    >
      {enabledPlans.map((subscriptionPlan, index) => (
        <Box
          key={`subscriptionPlan-${index}`}
          gridColumnStart={{
            lg: index === 0 && enabledPlans.length === 1 ? 2 : undefined,
          }}
        >
          <SubscriptionPlanCard
            subscriptionPlan={subscriptionPlan}
            onClick={onSelect}
          />
        </Box>
      ))}
    </SimpleGrid>
  );
};
